import React from 'react';
import PropTypes from 'prop-types';
import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';

export default function Card({ title, value }) {
  return (
    <StatisticButton
      label={title}
      value={value}
        // onClick={() => setShowModal(true)}
      className="bg-primary-100"
    />
  );
}

Card.propTypes = {
  value: PropTypes.number,
  title: PropTypes.string.isRequired,
};

Card.defaultProps = {
  value: null,
};
